var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62301 3.9093H3.17699C1.97999 3.9093 1 4.95906 1 6.24127V14.7594C1 15.8467 1.728 16.3115 2.617 15.7792L5.36799 14.137C5.66199 13.9646 6.138 13.9646 6.425 14.137L9.17599 15.7792C10.065 16.3115 10.793 15.8467 10.793 14.7594V6.24127C10.8 4.95906 9.82001 3.9093 8.62301 3.9093Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 6.24127V14.7594C10.8 15.8466 10.072 16.304 9.183 15.7792L6.43201 14.137C6.13801 13.9646 5.66199 13.9646 5.36799 14.137L2.617 15.7792C1.728 16.304 1 15.8466 1 14.7594V6.24127C1 4.95906 1.97999 3.9093 3.17699 3.9093H8.62301C9.82001 3.9093 10.8 4.95906 10.8 6.24127Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.33197V11.8501C15 12.9373 14.272 13.3947 13.383 12.8699L10.8 11.3252V6.24133C10.8 4.95911 9.82002 3.90936 8.62302 3.90936H5.20001V3.33197C5.20001 2.04976 6.18 1 7.377 1H12.823C14.02 1 15 2.04976 15 3.33197Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/asset.46c0ee23.svg";
export { ForwardRef as ReactComponent };